import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

const COLOR_PRESETS = [
  { name: "Tím Trezo", hex: "#605dff", dark: "#a78bfa" },
  { name: "Xanh dương", hex: "#3b82f6", dark: "#60a5fa" },
  { name: "Xanh lá", hex: "#10b981", dark: "#34d399" },
  { name: "Cam", hex: "#f97316", dark: "#fb923c" },
  { name: "Hồng", hex: "#ec4899", dark: "#f472b6" },
  { name: "Đỏ", hex: "#ef4444", dark: "#f87171" },
  { name: "Vàng", hex: "#eab308", dark: "#facc15" },
  { name: "Teal", hex: "#14b8a6", dark: "#2dd4bf" },
];

function applyPrimaryColor(hex, darkHex) {
  const root = document.documentElement;
  root.style.setProperty("--karinox-primary", hex);
  root.style.setProperty("--karinox-primary-dark", darkHex || hex);
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("karinox-theme") || "dark";
  });

  const [primaryColor, setPrimaryColor] = useState(() => {
    return localStorage.getItem("karinox-primary-color") || "#605dff";
  });

  const [primaryColorDark, setPrimaryColorDark] = useState(() => {
    return localStorage.getItem("karinox-primary-color-dark") || "#a78bfa";
  });

  useEffect(() => {
    localStorage.setItem("karinox-theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
    // Sync với Tailwind dark mode (config: darkMode=["class"])
    // để các utilities "dark:bg-..." hoạt động đồng bộ với data-theme.
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("karinox-primary-color", primaryColor);
    localStorage.setItem("karinox-primary-color-dark", primaryColorDark);
    applyPrimaryColor(primaryColor, primaryColorDark);
  }, [primaryColor, primaryColorDark]);

  const toggleTheme = () => setTheme(prev => prev === "dark" ? "light" : "dark");

  const setColor = (hex, darkHex) => {
    setPrimaryColor(hex);
    setPrimaryColorDark(darkHex || hex);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, primaryColor, primaryColorDark, setColor, COLOR_PRESETS }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
